export {filterDOMProps} from '../src/utils/filterDOMProps';
